<script setup>
import { isEmpty } from 'lodash'
import { computed, inject, toValue } from 'vue'
import { useStore } from 'vuex'

import { ACTIONS_KEYS } from '@/utils/actions-keys'
import { DROPDOWN_MENU_TYPES } from '@/utils/components-configurations/dropdown-menu'
import {
  getAddObjectiveButtonDisabledState,
  getDashboardState,
  MODULE_LIMIT
} from '@/utils/custom-dashboard-helper'
import { MENU_ITEMS_GROUPS } from '@/utils/dropdown-menu'
import { customDashboardStateInjectionKey } from '@/utils/injection-keys'

import AppButton from '@/components/ui/AppButton/AppButton'
import DropdownMenu from '@/components/ui/DropdownMenu/DropdownMenu'

defineOptions({
  name: 'ModuleDropdownMenu'
})

const props = defineProps({
  formModel: {
    type: Object,
    required: true
  }
})

const { isOwner, isPluginAdmin, isEditor } = getDashboardState()

const { EDITING, REMOVING } = MENU_ITEMS_GROUPS
const { REMOVE, EDIT, ADD, DUPLICATE } = ACTIONS_KEYS

const store = useStore()
const dashboardItem = computed(() => store.state.dashboard.dashboardItem)
const isModuleLimitReached = computed(() => dashboardItem.value.modules.length >= MODULE_LIMIT)

const DROPDOWN_MENU_ACTIONS = computed(() => {
  const result = []

  if (isOwner.value || isPluginAdmin.value || isEditor.value) {
    const { elements = [] } = props.formModel

    const { disabled, tooltipContent } = getAddObjectiveButtonDisabledState({
      alreadyAddedObjectivesCount: elements.length
    })

    result.push({
      name: ADD,
      title: 'dashboard.add_elements',
      icon: 'goal-next',
      group: EDITING,
      disabled,
      tooltipContent
    })

    result.push({
      name: EDIT,
      title: 'action.edit',
      icon: 'edit-next',
      group: EDITING
    })

    if (!isModuleLimitReached.value) {
      result.push({
        name: DUPLICATE,
        title: 'dropdown.copy',
        icon: 'duplicate-next',
        group: EDITING
      })
    }

    // if (props.formModel.typeId === MODULE_TYPE_IDS.OKR && !isEmpty(props.formModel.elements)) {
    //   result.push({
    //     name: EXPORT,
    //     icon: 'export-pdf',
    //     title: 'dashboard.export_as_pdf',
    //     group: EDITING
    //   })
    // }

    result.push({
      name: REMOVE,
      title: 'action.delete',
      icon: 'delete-next',
      color: 'var(--grade-low-color-next)',
      group: REMOVING
    })
  }

  return result.filter(Boolean)
})

const customDashboardState = inject(customDashboardStateInjectionKey)

const onMenuActionsClick = name => {
  const state = toValue(customDashboardState)

  if (name === EDIT) {
    state.editModule(props.formModel)
  } else if (name === DUPLICATE) {
    state.duplicateModule(props.formModel)
  } else if (name === REMOVE) {
    state.removeModule(props.formModel)
  } else if (name === ADD) {
    state.addElementsToModule(props.formModel)
  }
  // else if (name === EXPORT) {
  //   state.exportModule(props.formModel.id)
  // }
}
</script>

<template>
  <DropdownMenu
    v-if="!isEmpty(DROPDOWN_MENU_ACTIONS)"
    :items="DROPDOWN_MENU_ACTIONS"
    :offset="[0, 0]"
    :type="DROPDOWN_MENU_TYPES.DEFAULT_NEXT"
    data-export-ignore
    preferred-position="bottom-end"
    @item-click="onMenuActionsClick"
  >
    <template #activator>
      <AppButton data-export-ignore icon="more-next" size="sm" type="subtle" />
    </template>
  </DropdownMenu>
</template>

<style lang="scss" scoped></style>
